import React from 'react';

const Table = ({ data, columns, onEdit, onDelete, renderActions, rowKey = 'id' }) => {
  if (!data || data.length === 0) {
    return <div className="empty-state">No data available</div>;
  }

  const hasActions = !!(onEdit || onDelete || renderActions);

  const getKey = (row) => row[rowKey] ?? row.id ?? row.inventory_items_id;

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {hasActions && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={getKey(row)}>
              {columns.map((col) => {
                const value = row[col.key];
                return (
                  <td key={col.key}>
                    {col.format ? col.format(value, row) : value || '-'}
                  </td>
                );
              })}
              {hasActions && (
                <td className="actions-cell">
                  {renderActions && renderActions(row)}
                  {onEdit && (
                    <button
                      className="btn-edit"
                      onClick={() => onEdit(row)}
                      title="Edit"
                    >
                      ✏️
                    </button>
                  )}
                  {onDelete && (
                    <button
                      className="btn-delete"
                      onClick={() => onDelete(getKey(row))}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;


